import EntitleUser from './EntitleUser';

export default EntitleUser;
